import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Panel, Button, Col, Row } from 'react-bootstrap';
import { Input, FormActions } from '../../../common/components/formControls';
import { withTranslation } from 'react-i18next';

const Filter = ({ handleSubmit, onReset, pristine, submitting, t, reset, initialize }) => {

	const handleReset = () => {
		initialize({});
		onReset();
	};

	return (
		<Panel>
			<Panel.Heading>{t('SelectChildForMove_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit}>
					<Row>
						<Col sm={6}>
							<Field name='name' component={Input} type='text' label={t('MoveLessons_Child')} />
						</Col>
						<Col sm={6}>
							<Field name='parent' component={Input} type='text' label={t('MoveLessons_Parent')} />
						</Col>
					</Row>
					<FormActions>
						<Button type='submit' disabled={submitting} bsStyle='primary'>{t('SelectChildForMove_Search')}</Button>
						<Button disabled={submitting} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'moveLessonsChildFilter' })(withTranslation()(Filter));